import { useState, useEffect } from 'react';
import { TopToolbar, useRecordContext, AutocompleteInput, ExportButton, Button, List, Datagrid, TextField, EmailField, TextInput, ReferenceInput, SelectInput, ReferenceField, Edit, SimpleForm, useGetList, useDataProvider, Create, required, DateTimeInput, DateField } from 'react-admin';
import IconAdd from '@mui/icons-material/Add';

import * as React from 'react';
import Box from '@mui/material/Box';
//import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import {default as MUITextField} from '@mui/material/TextField';
import {default as MUIButton} from '@mui/material/Button';
import {default as MUIButtonGroup} from '@mui/material/ButtonGroup';
import {default as MUIMenuItem} from '@mui/material/MenuItem';
import {default as MUISelect} from '@mui/material/Select';
import {default as FormControl} from '@mui/material/FormControl';

import {fetcherGetSync, fetcherSync} from "../utils/fetcher";
import config from "../config";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const titleStyle = {
    textAlign: "center"
}

const buttonGroupStyle = {
    marginTop: "20px"
}

export default function RegulateOrderPriceModal(props) {
    const record = useRecordContext();
    const handleClose = () => {props.setOpened(false)};

    const amount = props.amount;
    const opened = props.opened;
    const clientId = props.clientId;

    function autoDebit(amount){
        handleClose();
        let result = fetcherSync(config.API_HOST+"/orders/"+record.id+"/debit", "POST", {debitPrice: amount*100, clientId: record.clientId});
        if(result.success){      
            if(result.transactionResult.next_url.length > 0){
              console.log("result.next_url");   
              console.log(result.transactionResult.next_url);   
              window.location.href = result.transactionResult.next_url;
            }
            else {
                handleClose();
                alert("Le client a bien été débité.");
                setTimeout(() => window.location.reload(), 1000);
            }

        }
        else {
            alert("Stripe n'est pas en mesure de débiter automatiquement cette CB. Veuillez générer un lien de paiment.")
        }
    }

    function generatePaymentLink(amount){
        handleClose();
        let result = fetcherSync(config.API_HOST+"/orders/"+record.id+"/transaction/add", "POST", {
            amount: amount*100,
            successUrl: config.WEBSITE_URL+"/page/paiement-valide",
            cancelUrl: config.WEBSITE_URL+"/page/paiement-refuse",
        });
        if(result.status && result.status.localeCompare("open") == 0){
            handleClose();
            alert("Lien de paiement créé : "+result.url+"\n\nVous pouvez copier ce lien dans l'onglet transactions.");
        }
        else {
            alert(result.message);
        }
    }

    return (
        <Modal
            open={opened}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2" style={titleStyle}>
                    Régulariser la commande
                </Typography>

                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    Il reste {amount}€ à débiter.
                </Typography>

                <MUIButtonGroup size="small" variant="contained" aria-label="outlined primary button group" style={buttonGroupStyle}>
                    <MUIButton color="success" onClick={() => {handleClose(); autoDebit(amount)}}>Débiter automatiquement</MUIButton>
                    <MUIButton color="secondary" onClick={() => {handleClose(); generatePaymentLink(amount)}}>Générer un lien de paiement</MUIButton>
                </MUIButtonGroup>

            </Box>
        </Modal>
    );
}